import React,{useState, useEffect, useRef ,useCallback} from 'react'
import { useForm } from 'react-hook-form'
import { useSelector,useDispatch } from 'react-redux'
import { useAlert } from 'react-alert'
import { makeStyles } from '@material-ui/core/styles';
import FUNC from '../../../Common/FunctionEnum'
import Modal from '@material-ui/core/Modal';
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Calendar from '../../../Common/Atoms/MonthCalendar'
import Button from '../../../Common/Atoms/NormalButton'

export const defaultUrl = '/api/paymentDuductionManagement/paymentDuduction'

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const ContentWrap = styled.div`
  display: flex;
  flex-direction: column;
`

const TitleWrap = styled.div`
  font-size: 24px;
  display: flex;
  padding: 1vw;
  font-weight: bold;
`
const RadioWrap = styled.div`
  display: flex;
  font-size: 18px;
  justify-content: center;
  padding: 10px;
`
const FormWrap = styled.form`
  display: flex;
`
const TableWrap = styled.div`
  display: flex;
  padding: 1vw;
`

const ButtonsWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1vw;
`

const PaymentPrintDialog = ({ open, onCloseFunc,onPayment, paymentDateRef,fromDate}) => {
  const { register, handleSubmit, getValues, setError, setValue, watch, reset, errors, control } = useForm({ validateCriteriaMode: 'all' })
  const classes = useStyles();
  const alert = useAlert()
  const dispatch = useDispatch()

  const [paymentDate, setPaymentDate] = useState()
  const changeCalendar = (date) => {
    paymentDateRef.current = date;
    console.log(date,paymentDateRef.current)
    setPaymentDate(paymentDateRef.current)
  }

  const { loginUserInfo } = useSelector(state => state)
  const grants = loginUserInfo.menuList && loginUserInfo.menuList.find(menu => menu.functionMenuId === FUNC.ATTENDANCE)


  const onSubmit=()=>{
    onCloseFunc()
    onPayment()
  }
  //ダイアログ表示時の処理
  useEffect(() => {
    console.log(fromDate)
    changeCalendar(fromDate)
  // 必要なデータが更新された場合のみ実行
  // eslint-disable-next-line
  }, [open])


  return (
    <Modal
      open={open}
      onClose={()=>onCloseFunc()}
      aria-labelledby='給与明細出力'
      aria-describedby='給与明細出力ダイアログ'
      style={{display:'flex',alignItems:'center',justifyContent:'center'}}
    >
    <FormWrap className='h-dsm'> 
    <div className={classes.paper}>
      <ContentWrap>
      <TitleWrap>
          <label>給与明細出力</label>
      </TitleWrap>
      </ContentWrap>
      <TableWrap>
        <label style={{marginTop:'6px',marginLeft:'0px',width:'6rem' ,fontWeight: 'bold',fontSize:'18px'}}>対象年月</label>
        <Calendar changeCalendar={changeCalendar} dataValue={paymentDate} isViewIcon placeholder={'対象年月'}/>
      </TableWrap>
      <ButtonsWrap>
        <Button name='出力' padding='0 0 12px 0' type='button' onClick={()=>onSubmit()}/>
        <Button name='キャンセル' padding='0px' onClick={onCloseFunc} />
      </ButtonsWrap>
    </div>
    </FormWrap>
  </Modal>
  )
}

PaymentPrintDialog.propTypes = {
    open: PropTypes.bool,
    closeFunc: PropTypes.func,
    updatedShiftFunc: PropTypes.func,
    defaultUrl: PropTypes.string,
    dailyWorkInfo: PropTypes.object,
    workDivisions: PropTypes.array,
}

export default PaymentPrintDialog
